/**
 * Created by Administrator on 2018/5/2.
 */
// import {StorageUtil} from '../common/Auth.js';

var store = {};

store.ajax = {
  timer: null,
  status: false, //是否在进行请求
  num: 0, //正在请求的数量
};
// store.wrap={
//     messageCount:0,
//     unreadCount:0,
// };
//手动选择位置
store.chooseArea = {"code": "510104", "desc": "锦江区"};
//选择城市中文对象{code:"",desc: "",detailDesc:""}
store.choosedCitys = new Array();
//自动定位位置{code:"",desc:"",detailDesc:"",latLng:""}
store.localtionArea = {
  code: "510104",
  desc: "锦江区",
  detailDesc: "四川省-成都市-锦江区",
  latLng: "104.0658,30.65734"
};


//图书默认图片
store.imgError_headerIco = 'this.src="' + require('../assets/images/headerIco.png') + '"';
store.imgError = 'this.src="' + require('../assets/images/noimg.png') + '"';
store.imgError_library = 'this.src="' + require('../assets/images/library_noImg.jpg') + '"';

//图书馆详情
store.libraryInfo = {
  lngLat: '',//经纬度
  image: {
    imagePath: 'https://wx3.sinaimg.cn/crop.0.0.998.562/90eb2137ly1fpt9ebveoyj20rs0fmtdx.jpg'
  },
},
  store.func = {
    //得到登录user
    getUserObj: function () {
      if (store.user == "null" || store.user == null || store.user == ""
        || store.user == {} || store.user == undefined) {
        return null;
      } else {
        return JSON.parse(JSON.stringify(store.user));
      }
    },
    //得到登录user的身份证信息
    getUserIdCard: function () {
      if (store.user == "null" || store.user == null || store.user == ""
        || store.user == {} || store.user == undefined) {
        return "";
      } else {
        if (store.user.idCard == null && store.user.idCard == undefined) {
          return "";
        } else {
          return store.user.idCard;
        }
      }
    },
    //得到登录user的readerId
    getUserReaderId: function() {
      if(store.user == 'null' || store.user == null || store.user == '' || store.user == {} || store.user == undefined){
        return ""
      } else {
        if(store.user.readerId == null && store.user.readerId == undefined) {
          return ""
        } else {
          return store.user.readerId;
        }
      }
    },
    //获取token
    getToken: function () {
      if (store.token == "null" || store.token == null || store.token == ""
        || store.token == {} || store.token == undefined) {
        return '';
      } else {
        return store.token;
      }
    }
  }
  /*0:平台，1：官网 */
  store.webType = 0;
  store.opacType = 0;/*0:不是OPAC，1：是OPAC */
  store.library = null; /*图书馆信息*/
export {store}
